import { render, staticRenderFns } from "./5_BaisseCA.vue?vue&type=template&id=1bc994b9&scoped=true&"
import script from "./5_BaisseCA.vue?vue&type=script&lang=js&"
export * from "./5_BaisseCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc994b9",
  null
  
)

export default component.exports